// extracted by mini-css-extract-plugin
module.exports = {"autoClose":"y5hT0","autoCloseTimer":"MMc2g","grayBorder":"LM23w","timer":"peap_","colorBorder":"qME6o","spin":"SC0eI","closeBtn":"LoHos"};